// extracted by mini-css-extract-plugin
export default {"text-wrapper":"K3k19","main-title":"lJqfQ","form-container":"VfKXh","title":"QhGht","companies-input":"MLY3R","input-form":"luxRG","description":"JM7K1"};